import React from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'
import NewEstate from './NewEstate'
import ProductSelection from './ProductSelection'
import Recipient from './Recipient'

import './index.scss'

const Routes = ({match}) => {
  return (
    <Switch>
      <Route path={`${match.url}/bekreftelse/:orderId`} component={Recipient} />
      <Route path={`${match.url}/ny/:webOrderId?`} component={NewEstate} />
      <Route path={`${match.url}/:webOrderId`} component={ProductSelection} />

      <Redirect to={`${match.url}/ny`} />
    </Switch>
  )
}

export default Routes
